import {
  FilterFilled,
  FilterOutlined,
  OrderedListOutlined,
  ProfileOutlined,
  PlusOutlined,
  FormOutlined,
  RobotOutlined,
} from "@ant-design/icons";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { fetchWorkflow } from "../../store/workflow";
import { Checkbox, Dropdown, Menu } from "antd";
import useDispatchWithResult from "../../hooks/useDispatchWithResult";
import { acessoSelector } from "../../store/acessos";
import { fetchEmpresas } from "../../store/empresas";
import ActionLink from "../action-link";
import EmpresaDrawer from "./_EmpresaDrawer";
import styles from "./_styles.less";
import { funcoesSelector } from "../../store/autenticacao";
import unwrapAxiosPromise from "../../util/unwrapAxiosPromise";
import { isGestorSelector } from "../../store/autenticacao";
import { useRouteMatch, useHistory } from "react-router";
import TiposTarefasDrawer from "./TiposTarefas";
import { fetchVerificarLimite } from "../../store/empresa";

export default function WorkflowMenu({ showCreate, extraMenu }) {
  const { t } = useTranslation();
  const match = useRouteMatch();
  const history = useHistory();
  const workflowId = match.params.id;
  const dispatch = useDispatchWithResult();
  const funcoes = useSelector(funcoesSelector);
  const acesso = useSelector(acessoSelector);
  const isGestor = useSelector(isGestorSelector);

  const [empresa, setEmpresa] = useState();
  const [filterVisible, setFilterVisible] = useState(false);
  const [checkFilter, setCheckFilter] = useState(false);
  const [empresaDrawerVisible, setEmpresaDrawerVisible] = useState(false);
  const [TiposTarefasDrawerVisible, setTiposTarefasDrawerVisible] = useState(false);

  const hasCadastro = funcoes?.includes("cadastro") && acesso?.funcoes?.includes("cadastro");

  const handleCreateManual = () => {
    unwrapAxiosPromise(dispatch(fetchVerificarLimite())).then(() => {
      setEmpresa({ acessoId: acesso?.id });
      setEmpresaDrawerVisible(true);
    });
  };

  const handleCreateAssistente = () => {
    history.push("/societario/assistente");
  };

  const handleCreateTarefas = () => {
    setTiposTarefasDrawerVisible(true);
  };

  const handleEmpresaChange = () => {
    dispatch(fetchEmpresas({ acessoId: acesso?.id, modulo: "workflow" }));
  };

  const handleEmpresaDrawerClose = () => {
    setEmpresaDrawerVisible(false);
  };

  const handleTiposTarefasDrawerClose = () => {
    setTiposTarefasDrawerVisible(!TiposTarefasDrawerVisible);
  };

  const handleEmpresaDrawerAfterClose = () => {
    setEmpresa(undefined);
  };

  const handleFilterAvisosChange = () => {
    setCheckFilter(!checkFilter);
    unwrapAxiosPromise(dispatch(fetchWorkflow({ workflowId, arquivamento: !checkFilter })));
  };

  const buttons = [];

  buttons.push(
    <ActionLink
      key="tarefas"
      noTitle
      title={t("Visualizar Tipos Tarefas")}
      icon={<OrderedListOutlined />}
      onClick={handleCreateTarefas}
    />
  );

  buttons.push(
    <Dropdown
      key="filter-dropdown"
      overlay={
        <Menu
          theme="dark"
          mode="horizontal"
          selectable={false}
          disabledOverflow
        >
          <Menu.ItemGroup
            title={t("Exibir")}
            className={styles["workflow-menu-item-group"]}
          >
            <Menu.Item
              key="Arquivadas"
              className={styles["workflow-menu-item"]}
            >
              <Checkbox
                checked={checkFilter}
                onChange={handleFilterAvisosChange}
              >
                {t("Apenas Arquivadas")}
              </Checkbox>
            </Menu.Item>
          </Menu.ItemGroup>
        </Menu>
      }
      open={filterVisible}
      onOpenChange={setFilterVisible}
      trigger={["click"]}
    >
      <ActionLink
        key="filter"
        noTitle
        icon={checkFilter ? <FilterFilled /> : <FilterOutlined />}
      />
    </Dropdown>
  );

  if (showCreate && hasCadastro) {
    const createMenu = (
      <Menu
        theme="dark"
        onClick={({ key }) => {
          if (key === "manual") handleCreateManual();
          if (key === "assistente") handleCreateAssistente();
        }}
      >
        <Menu.Item key="manual" icon={<FormOutlined />}>
          {t("Criar empresa manualmente")}
        </Menu.Item>
        <Menu.Item key="assistente" icon={<RobotOutlined />}>
          {t("Criar empresa por assistente")}
        </Menu.Item>
      </Menu>
    );

    buttons.push(
      <Dropdown
        key="create-dropdown"
        overlay={createMenu}
        trigger={["click"]}
        placement="bottomRight"
        destroyPopupOnHide
      >
        <ActionLink
          key="create"
          noTitle
          icon={<ProfileOutlined />}
        />
      </Dropdown>
    );
  }

  if (extraMenu && extraMenu.length > 0) buttons.push(extraMenu);

  return (
    <div className={styles["workflow-menu"]}>
      {buttons}
      {hasCadastro && (
        <EmpresaDrawer
          value={empresa}
          onChange={handleEmpresaChange}
          visible={empresaDrawerVisible}
          onClose={handleEmpresaDrawerClose}
          onAfterClose={handleEmpresaDrawerAfterClose}
        />
      )}
      {isGestor && (
        <TiposTarefasDrawer
          visible={TiposTarefasDrawerVisible}
          onClose={handleTiposTarefasDrawerClose}
          workflowId={workflowId}
        />
      )}
    </div>
  );
}

WorkflowMenu.propTypes = {
  showCreate: PropTypes.bool,
  showFilter: PropTypes.bool,
  extraMenu: PropTypes.array,
};
